/* eslint-disable */
// @typescript-eslint/ban-ts-comment
// @ts-nocheck
// TODO: поправить типы
import { injectable } from 'tsyringe';
import React from 'react';
import {
  DateRangeFilterStoreFactory,
  DateRangeValue,
  Identifiable,
  SearchOptionsDelegate,
  SelectFilterStoreFactory,
  MultipleOptionsTextFilter,
  MultipleOptionsTextFilterStoreFactory,
  DateWidgetStoreFactory,
} from '@custis/common';
import { FilterWrapper, HeaderCellSelectFilter, DateRangeColumnFilter, DateColumnFilter } from './components';
import { GridFilterProps } from './filters';
import { TTableColumn } from './models';
import { uniqueId } from 'lodash';
import s from './Grid.module.less';

/**
 * Фабрика для создания колонок
 * Инкапсулирует логику создания колонок, а так же связь между конечным компонентом фильтра и его враппером
 */
@injectable()
export class ColumnFactory<TItem extends Identifiable, TFilter, TSorting> {
  constructor(
    private multipleFilterStoreFactory: MultipleOptionsTextFilterStoreFactory,
    private selectFilterStoreFactory: SelectFilterStoreFactory,
    private dateRangeFilterStoreFactory: DateRangeFilterStoreFactory,
    private dateWidgetStoreFactory: DateWidgetStoreFactory,
  ) {}

  create(options: TTableColumn<TItem, TFilter, TSorting>): TTableColumn<TItem, TFilter, TSorting> {
    return {
      ...options,
      disableFilters: true,
      type: options.type ?? 'string',
      fieldType: options.fieldType ?? 'string',
    };
  }

  createWithTextFilter(options: TTableColumn<TItem, TFilter, TSorting>): TTableColumn<TItem, TFilter, TSorting> {
    const store = this.multipleFilterStoreFactory.create();
    const id = options.id || uniqueId();
    return {
      ...this.create(options),
      disableFilters: false,
      // eslint-disable-next-line react/display-name
      Filter: (props: GridFilterProps<string[]>) => {
        const { onConfirm, onReset, ...restProps } = props;
        const onFind = (v?: string[] | undefined) => {
          if (store.value !== '') {
            store.addOption(store.value);
          }
          setTimeout(() => {
            onConfirm(v ?? store.options);
          }, 100);
        };
        const onClear = () => {
          store.clearField();
          onReset();
        };
        return (
          <FilterWrapper {...restProps} onConfirm={onFind} onReset={onClear}>
            <MultipleOptionsTextFilter
              {...restProps}
              onReset={onClear}
              onConfirm={onFind}
              store={store}
              id={id}
              separators={[' ', '\n', '\t']}
              className={s.MultipleText}
            />
          </FilterWrapper>
        );
      },
    };
  }

  createWithDateFilter(options: TTableColumn<TItem, TFilter, TSorting>): TTableColumn<TItem, TFilter, TSorting> {
    const store = this.dateWidgetStoreFactory.create();
    return {
      ...this.create(options),
      disableFilters: false,
      // eslint-disable-next-line react/display-name
      Filter: (props: GridFilterProps<string[]>) => <DateColumnFilter column={options} store={store} {...props} />,
    };
  }

  createWithSelectFilter<TFilterKey extends number | string>(
    options: TTableColumn<TItem, TFilter, TSorting>,
    search: SearchOptionsDelegate<TFilterKey>,
  ): TTableColumn<TItem, TFilter, TSorting, TFilterKey> {
    const store = this.selectFilterStoreFactory.create(search);
    return {
      ...this.create(options),
      disableFilters: false,
      // eslint-disable-next-line react/display-name
      Filter: (props: GridFilterProps<(number | string)[]>) => (
        <HeaderCellSelectFilter {...props} store={store} column={options} />
      ),
    };
  }

  createWithSingleSelectFilter<TFilterKey extends number | string>(
    options: TTableColumn<TItem, TFilter, TSorting>,
    search: SearchOptionsDelegate<TFilterKey>,
  ): TTableColumn<TItem, TFilter, TSorting, TFilterKey> {
    const store = this.selectFilterStoreFactory.create(search);
    return {
      ...this.create(options),
      disableFilters: false,
      // eslint-disable-next-line react/display-name
      Filter: (props: GridFilterProps<(number | string)[]>) => (
        <HeaderCellSelectFilter {...props} store={store} column={options} mode={'single'} />
      ),
    };
  }

  createWithDateRangeFilter(options: TTableColumn<TItem, TFilter, TSorting>): TTableColumn<TItem, TFilter, TSorting> {
    const store = this.dateRangeFilterStoreFactory.create();
    return {
      ...this.create(options),
      disableFilters: false,
      Filter: (props: GridFilterProps<DateRangeValue>) => {
        return <DateRangeColumnFilter column={options} store={store} {...props} />;
      },
    };
  }
}
